/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// --- Top banner: switch fade -> horizontal slide (2026-07-17) ---
(function () {
  function convertToSlide($) {
    var $c = $('.js-home-carousel');
    if (!$c.length || !$c.hasClass('slick-initialized')) return false;
    var slick;
    try { slick = $c.slick('getSlick'); } catch (e) { return true; }
    if (!slick || !slick.options) return true;
    if (slick.options.fade) {
      var opts = $.extend(true, {}, slick.options);
      opts.fade = false;
      if (!opts.speed || opts.speed < 1) opts.speed = 500;
      if (!opts.cssEase || opts.cssEase === 'linear') opts.cssEase = 'ease';
      try {
        $c.slick('unslick');
        $c.slick(opts);
      } catch (e) {}
    }
    return true;
  }
  function boot() {
    if (!window.jQuery) return;
    var $ = window.jQuery, tries = 0;
    var iv = setInterval(function () {
      if (convertToSlide($) || ++tries > 60) clearInterval(iv);
    }, 150);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
